import { IRevenueAgencyListTableLang } from '../../../types/lang'

export const revenueAgencyListTableLang: IRevenueAgencyListTableLang = {
	revenue_agency_list_table: {
		column_id: 'ID_ru',
		column_name: 'Name_ru',
		column_date_updated: 'Date Updated_ru',
		column_group: 'Group_ru',
		column_percent: 'Percent, %_ru',
		column_is_system: 'System_ru',
		column_is_active: 'Active_ru',
		column_is_hold: 'Hold_ru',
		column_fake_type: 'Fake Type_ru',
		column_history: 'History_ru',
		column_notes: 'Notes_ru'
	}
}